// extracted by mini-css-extract-plugin
module.exports = {"button":"_2cMHO","buttonActive":"_2DLkP","text":"_255y0","textActive":"gkhNp","outline":"_2G5YV","outlineActive":"_3Ge1J"};